import { render, staticRenderFns } from "./ProjectSiteListingOngoingSN.vue?vue&type=template&id=6f8083a4"
import script from "./ProjectSiteListingOngoingSN.vue?vue&type=script&lang=js"
export * from "./ProjectSiteListingOngoingSN.vue?vue&type=script&lang=js"
import style0 from "./ProjectSiteListingOngoingSN.vue?vue&type=style&index=0&id=6f8083a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports